/**
 * Util to convert from the DAM's quoted-csv format for multiselects to a normal array
 * @param csv CSV string to convert
 * @param sep Separator
 * @returns Array
 *
 * @example
 * ```ts
 * const array = csvToArray('a,b,c'); // ['a', 'b', 'c']
 * ```
 */
export const csvToArray = (csv?: string[] | string, sep = ',') => {
	if (!csv) return [];
	if (Array.isArray(csv)) return csv;

	// the server will not wrap values in additional quotes if there is only 1 value
	// if we parse that one value we may end up splitting a value that contains commas
	// so, if we start with a " and end with a "
	// single value example string: "Half sunk a shattered visage lies, whose frown,"
	// multiple value example string: "\"Who said—“Two vast and trunkless legs of stone\",\"\"I met a traveller from an antique land,\""
	if (csv.slice(0, 1) !== '"' && csv.slice(-1) !== '"') {
		return [csv];
	}

	// https://greywyvern.com/?post=258
	for (
		// eslint-disable-next-line no-var
		var foo = csv.split((sep = sep || ',')), x = foo.length - 1, tl;
		x >= 0;
		x--
	) {
		if (foo[x].replace(/"\s+$/, '"').charAt(foo[x].length - 1) == '"') {
			if (
				(tl = foo[x].replace(/^\s+"/, '"')).length > 1 &&
				tl.charAt(0) == '"'
			) {
				foo[x] = foo[x].replace(/^\s*"|"\s*$/g, '').replace(/""/g, '"');
			} else if (x) {
				foo.splice(x - 1, 2, [foo[x - 1], foo[x]].join(sep));
			} else foo = foo.shift()?.split(sep).concat(foo) || [''];
		} else foo[x].replace(/""/g, '"');
	}
	return foo
		.map((f) => f.replace(/\\'/g, "'"))
		.filter((f) => f != null && f !== '');
};

export default csvToArray;
